import HttpResponse from "../../../../utils/http/http.response";

export type OrderUpdateResponseSuccessResponse = HttpResponse<string>;

export enum OrderUpdateErrorType {
  PASSENGERS_DO_OVERLAP = "PASSENGERS_DO_OVERLAP",
  NODE_ALREADY_CHECKED_OUT = "NODE_ALREADY_CHECKED_OUT",
  RESULT_TIMING_NOT_POSSIBLE = "RESULT_TIMING_NOT_POSSIBLE",
}

export enum OrderUpdateUnprocessableEntityErrorType {
  TOO_LONG_RIDE = "TOO_LONG_RIDE",
}

export type OrderUpdateUnprocessableEntityTimeError = {
  detail: {
    errorCode: OrderUpdateUnprocessableEntityErrorType.TOO_LONG_RIDE;
  }[];
};

export type OrderUpdateNotAcceptableResponsePassengerDoOverlapError = {
  errorType: OrderUpdateErrorType.PASSENGERS_DO_OVERLAP;
  subjectOrderId: string;
};

export type OrderUpdateNotAcceptableResponseResultTimingNotPossible = {
  errorType: OrderUpdateErrorType.RESULT_TIMING_NOT_POSSIBLE;
};

export type OrderUpdateNotAcceptableResponseNodeAlreadyCheckedOutError = {
  errorType: OrderUpdateErrorType.NODE_ALREADY_CHECKED_OUT;
};

export type OrderUpdateNotAcceptableResponseError =
  | OrderUpdateNotAcceptableResponsePassengerDoOverlapError
  | OrderUpdateNotAcceptableResponseNodeAlreadyCheckedOutError
  | OrderUpdateNotAcceptableResponseResultTimingNotPossible;

export type OrderUpdateNotAcceptableResponse =
  HttpResponse<OrderUpdateNotAcceptableResponseError>;

export type OrderUpdateUnprocessableEntityResponse =
  HttpResponse<OrderUpdateUnprocessableEntityTimeError>;

type OrderUpdateResponse =
  | OrderUpdateResponseSuccessResponse
  | OrderUpdateNotAcceptableResponse
  | OrderUpdateUnprocessableEntityResponse;

export default OrderUpdateResponse;
